import { MouseEventHandler } from "react";
import StyledButton from "./styled-components/StyledButton";

interface CircleButtonProps {
  text: string;
  selected: boolean;
  value: number;
  onClick: MouseEventHandler;
}

function CircleButton({ text, selected, value, onClick }: CircleButtonProps) {
  return (
    <StyledButton selected={selected} value={value} onClick={onClick}>
      {text}
    </StyledButton>
  );
}

export default CircleButton;
